import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";


export const saveDetailProductSetting = async (productSettingId, groupCode, productName, productCode, description, srcImage, urlRedirect, buttonURL, client, noClient, order, contentIDBanner) => {

    let url = `/api/jsonws/invoke`;

    const resp = await api(url, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/digitalsale.surpriseboxsetting/update-product-setting': {
                    productSettingId: productSettingId,
                    groupCode: groupCode,
                    productName: productName,
                    productCode: productCode,
                    description: description,
                    srcImage: srcImage,
                    url: urlRedirect,
                    buttonUrl: buttonURL,
                    client: client,
                    noClient: noClient,
                    order: order,
                    contentIDBanner: contentIDBanner
                },
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();

    return JSON.parse(data);
}